module Meevo.Plugins.AdpIntegration {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class WorkActivitiesSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        protected workActivityDetail: Model.DataDetail = {};


        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                noun,
                identityService,
                sectionSecurityKey)
        }
    }
}